import React, { useState } from 'react'
import getConsolidatedShipment from '../../../../utils/helpers/getConsolidatedShipment'


import { useSearchResults } from '../../../../utils/Contexts/SearchResultsContext'
import { event } from 'jquery'

const Search = ({ usercode }) => {

    const [searchValue, setSearchValue] = useState('')

    const { searchResults, setSearchResults, searchState, setSearchState } = useSearchResults()

    const handleSearchInput = (event) => {
        if (!event) { return }

        if (event.target.value.length === 0) {
            setSearchValue('')
            setSearchResults([])
            setSearchState('start')
        }


        if (event.target.value.length > 3) {
            setSearchValue(event.target.value)
        }
    }

    const searchNew = async (event) => {
        if (!event) { return }
        if (!searchValue) { return }
        let dockSchedulerSearchResults = []
        
        if (event.key === 'Enter' && searchValue.length > 4) {
            
            setSearchState('loading')

            let url = `https://api.shippersedge.com/schedule/searchShipmentsDockManagerInterface/${usercode}/${searchValue}`
            let response = await fetch(url, {
                method: 'GET',
                headers: {
                    'x-api-Key': 'vdhy8wwjUJrwhxFpfuECTiAW'
                }
            })
            let data = await response.json()

            // Get shipment v4 objects for exact matches
            if (data && data.exactMatches.length > 0) {
                for (const ship of data.exactMatches) {
                    dockSchedulerSearchResults.push(ship)
                }
            }

            // If no exact matches, get shipment v4 objects for likeMatches
            if (dockSchedulerSearchResults.length === 0 && data && data.likeMatches.length > 0) {
                for (const ship of data.likeMatches) {
                    dockSchedulerSearchResults.push(ship)
                }
            }

            // Get full shipment v4 objects
            let initialSearchResults = []
            for (const ship of dockSchedulerSearchResults) {
                if (ship.is_order === 'Y' && ship.is_trip === 'Y') {
                    let shipmentV4Objecct = await getShipmentv4ObjectFromShipmentService(ship.webquotecontrol)
                    initialSearchResults.push(shipmentV4Objecct)
                }
                if (ship.is_order === 'Y' && ship.is_trip === 'N' && ship.trip) {
                    let consolidationV4Object = await getShipmentv4ObjectFromShipmentService(ship.trip) 
                    initialSearchResults.push(consolidationV4Object)
                }
            }

            setSearchResults(initialSearchResults)
            setSearchState('success')
        }        
    }

    const getShipmentv4ObjectFromShipmentService = async (shipmentId) => {
        let url = `https://api.shippersedge.com/v4/shipment/` + shipmentId + `?include=handlingUnits,details,customfieldValues,stopDetails`
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                'x-api-Key': 'vdhy8wwjUJrwhxFpfuECTiAW'
            }
        })
        let data = await response.json()
        return data
    }

    return (
        <div>
            <div className="form-floating">
                <input
                    type="search"
                    className="form-control"
                    id="search"
                    placeholder="Search Appointments"
                    autoComplete='off'
                    onChange={(event) => handleSearchInput(event)}
                    onKeyDown={(event) => searchNew(event)}
                />
                <label htmlFor="search">Search Appointments</label>
            </div>
        </div>
    )
}

export default Search